module.exports = __webpack_public_path__ + "static/img/4.6eb4f50.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/homepage/bcimg/4.jpg
// module id = Pdkd
// module chunks = 1